import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Our Next-Gen <span>Android App Development Services</span>
            </h2>
            <p>
              We craft dynamic and user-centric Android applications that give
              your business a competitive edge. Our expert team of Android app
              developers and designers ensure a seamless user experience
              building rich features in the application. Here are reliable
              Android app solutions that you can have right according to your
              requirements:
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Build Your Android App
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Android App Consultation</h4>
                  <p>
                    We bridge the gap between your ideas and Android user
                    expectations. Our Android app consultants project your
                    business to align with the specific needs of Android users,
                    ensuring a tailored strategy for your app. We help you make
                    informed decisions on the ideal Android platform with
                    effective strategies to stand out in the app store.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Android App Design</h4>
                  <p>
                    Our Android app designers are experts in creating exclusive
                    experiences within the expansive Android ecosystem. We
                    ensure your app stands out on every Android platform across
                    different devices with a stunning UI/UX. Trust our designers
                    to craft a seamless and memorable user experience that
                    resonates with users across all Android devices.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Custom Android App Development</h4>
                  <p>
                    We leverage the expertise of our Android application
                    developers to build problem-solving solutions that set the
                    trend. Using the latest stack, we develop complex and
                    scalable applications. Our custom Android app development
                    services are designed to meet the needs of a wide range of
                    industries worldwide, ensuring your app represents your
                    unique identity.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Android App Testing</h4>
                  <p>
                    We implement a mix of automated and manual testing
                    procedures to make sure your Android app is meeting quality
                    standards. Our Android app testing process maintains a
                    secure and performance-centric approach. As a result, we
                    deliver a smooth and glitch-free experience for your Android
                    app development software.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Android App Maintenance</h4>
                  <p>
                    Our Android application development ensures that your app
                    remains optimized and secure, after its initial launch. Our
                    team monitors metrics, addresses issues, and updates to
                    improve user experience. Further, we offer bug fixes,
                    compatibility updates, feature enhancements, and security
                    patches to ensure smooth operation across devices and OS
                    versions.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
